import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ScannedActionsSubject } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService, BackendFeatureService, LoginCheckService, LoginComponent } from 'gung-standard';

@Component({
    selector: 'colmec-login',
    templateUrl: './colmec-login.component.html',
    styleUrls: ['./colmec-login.component.scss'],
    standalone: false
})
export class ColmecLoginComponent extends LoginComponent {
  fieldTextType = false;

  constructor(
    protected authService: AuthService,
    protected formBuilder: FormBuilder,
    protected route: ActivatedRoute,
    protected router: Router,
    protected actions$: ScannedActionsSubject,
    protected loginCheckService: LoginCheckService,
    @Optional()
    protected oauth2Service: OAuthService,
    protected backendFeatureService: BackendFeatureService
  ) {
    super(authService, formBuilder, route, router, actions$, loginCheckService, oauth2Service, backendFeatureService);
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
}
